import { useEffect } from 'react';

// Store
import {
  useIsProjectsFetched,
  useAppStore,
  useIsAuthorized,
  useIsLoggingOut,
} from '@/stores';

// Constants

// Providers
import { useFirebase } from '@/providers/firebase';

/**
 * Auto-refresh projects data every hour
 * - Fetch on mount if not already fetched
 * - Auto refresh every hour via interval
 * - Cleans up interval on unmount
 * - Stops making API calls when user is not authorized or when force logout is in progress
 */
export const useGetProjects = () => {
  const isProjectsFetched = useIsProjectsFetched();
  const isAuthorized = useIsAuthorized();
  const isLoggingOut = useIsLoggingOut();
  const { getToken, isLoading } = useFirebase();

  // Initial fetch if needed
  useEffect(() => {
    const fetchProjects = async () => {
      const token = await getToken();

      await useAppStore
        .getState()
        .fetchProjects({ requestConfig: { token }, force: true });
    };

    // Only fetch if authorized, not logging out, and not loading
    if (!isProjectsFetched && !isLoading && isAuthorized && !isLoggingOut) {
      fetchProjects();
    }

    // Don't need to put "getToken" in the dependency array
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isProjectsFetched, isLoading, isAuthorized, isLoggingOut]);
};
